(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ChangeField', ChangeField);

    ChangeField.$inject = ['$resource'];

    function ChangeField ($resource) {
        var resourceUrl =  'api/change-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
